import React, { useState } from "react";

const LoadingButton = ({ title, custom_class, onClick, loadingBtn }) => {

    return (
        <button
            className={`d-flex align-items-center justify-content-center btn btn-icon ${custom_class}`}
            onClick={() => onClick()}
            style={{
                gap: "5px",
                minWidth: "120px",
            }}
            disabled={loadingBtn} // Disable the button while loading
        >
            {loadingBtn ? (
                <>
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>{title}</span>
                </>
            ) : (
                <span>{title}</span>
            )}
        </button>
    );
};

export default LoadingButton;
